module.exports = __webpack_public_path__ + "img/scanSuccess.9064419b.png";